module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz18-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_15",
      "id": "CC_15"
    }
  }, [_vm._v(" Russian Diplomat Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz18-3"
    }
  }, [_c('i', [_vm._v(" A flow-through breakthrough. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA91"
    }
  }, [_c('b', [_vm._v(" 4 small tea bags ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA8C"
    }
  }, [_c('b', [_vm._v(" ½ gallon water ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAXcq"
    }
  }, [_c('b', [_vm._v(" 1 teaspoon whole cloves ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAxn"
    }
  }, [_c('b', [_vm._v(" 1 stick cinnamon ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAveq"
    }
  }, [_c('b', [_vm._v(" 2 cups sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AjNB"
    }
  }, [_c('b', [_vm._v(" 1 cup orange juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "AId"
    }
  }, [_c('b', [_vm._v(" ½ cup lemon juice ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "ASaA"
    }
  }, [_c('b', [_vm._v(" 8 cups water ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pAiQY"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("P")]), _vm._v("ut tea bags in water. Add remaining ingredients and let come to a boil but do not boil. Simmer for 30 minutes. Very good reheated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAy_"
    }
  }, [_vm._v(" Makes about ¾ gallon.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAJ8"
    }
  }, [_c('i', [_vm._v("Toni and Neal Brower—Lewisville, North Carolina")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3a489ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter15.vue
// module id = 108
// module chunks = 0